import React from 'react';
import { Mail, Phone, Globe, MapPin } from 'lucide-react';
export function EmailSignatureMontassar() {
  return <div className="max-w-3xl mx-auto p-8" data-id="element-181">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-182">
        <table cellPadding="0" cellSpacing="0" border={0} style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: '15px',
        lineHeight: '1.4',
        borderCollapse: 'collapse'
      }} data-id="element-183">
          <tbody data-id="element-184">
            <tr data-id="element-185">
              <td style={{
              paddingRight: '32px',
              verticalAlign: 'middle',
              borderRight: '2px solid #1e293b',
              width: '140px'
            }} data-id="element-186">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wxtonoDTZefwd495z2JgnJ/LOGO_ET_SLOGAN_%281%29.jpg" alt="IPcom Logo" style={{
                width: '140px',
                height: 'auto',
                display: 'block'
              }} data-id="element-187" />
              </td>
              <td style={{
              paddingLeft: '32px',
              verticalAlign: 'middle'
            }} data-id="element-188">
                <table cellPadding="0" cellSpacing="0" border={0} style={{
                borderCollapse: 'collapse'
              }} data-id="element-189">
                  <tbody data-id="element-190">
                    <tr data-id="element-191">
                      <td style={{
                      paddingBottom: '10px'
                    }} data-id="element-192">
                        <div style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#0f172a',
                        marginBottom: '2px',
                        letterSpacing: '-0.01em',
                        lineHeight: '1.2'
                      }} data-id="element-193">
                          Montassar BOUGAMRA
                        </div>
                        <div style={{
                        fontSize: '15px',
                        color: '#475569',
                        fontWeight: '500',
                        lineHeight: '1.3'
                      }} data-id="element-194">
                          Chargé d'affaires, IPcom
                        </div>
                      </td>
                    </tr>
                    <tr data-id="element-195">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-196">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-197">
                          Mobile :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-198">
                          07 64 35 74 16
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-199">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-200">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-201">
                          Tél :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-202">
                          +33 (1) 47 90 08 19
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-203">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-204">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-205">
                          Email :{' '}
                        </span>
                        <a href="mailto:m.bougamra@ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-206">
                          m.bougamra@ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-207">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-208">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-209">
                          Web :{' '}
                        </span>
                        <a href="https://www.ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-210">
                          ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-211">
                      <td style={{
                      paddingTop: '8px'
                    }} data-id="element-212">
                        <div style={{
                        fontSize: '13px',
                        color: '#64748b',
                        lineHeight: '1.4',
                        fontWeight: '400'
                      }} data-id="element-213">
                          17, Avenue des Louvresses, bât B2
                          <br data-id="element-214" />
                          92230 Gennevilliers, France
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}